import type { IBasketItem } from '../modules/basket/models';
import type { IConsumerCategory } from '../modules/common/models/productModels';

// 1) Klucze produktu — wyłącznie `id` (UUID); API nie zwraca już `productId`.
export const getCartProductKey = (it: IBasketItem): string =>
  String(it.item?.id ?? '');

export const getProductKey = (p: any): string => String(p?.id ?? '');

// 2) Flaga „czy ta linia jest samodzielna”
export function isLineStandaloneEligible(item: IBasketItem): boolean {
  const cat = item.item?.consumerCategories?.find(
    (c: any) => c.id === item.consumerCategoryId
  ) as IConsumerCategory | undefined;
  const flag = (cat as any)?.settings?.allowStandalonePurchase;
  // domyślnie TRUE, więc tylko false blokuje
  return flag !== false;
}

// 3) Czy w koszyku *cokolwiek* jest samodzielne (globalnie)
export function hasStandaloneEligibleItem(items: IBasketItem[]): boolean {
  return items.some(isLineStandaloneEligible);
}

// 4) Czy w koszyku jest samodzielna pozycja TEGO SAMEGO produktu
export function cartHasEligibleForSameProduct(
  items: IBasketItem[],
  product: any
): boolean {
  const key = getProductKey(product);
  if (!key) return false;
  return items.some(
    (it) => getCartProductKey(it) === key && isLineStandaloneEligible(it)
  );
}

// 5) Czy kategoria po id jest samodzielna
export function isCategoryStandaloneEligibleById(
  product: any,
  categoryId?: string
): boolean {
  if (!categoryId) return true;
  const cat = product?.consumerCategories?.find(
    (c: any) => c.id === categoryId
  );
  const flag = cat?.settings?.allowStandalonePurchase;
  return flag !== false;
}

// 6) Bezpośrednio na obiekcie kategorii
export function isCategoryStandaloneEligible(
  cat?: IConsumerCategory | null
): boolean {
  const flag = (cat as any)?.settings?.allowStandalonePurchase;
  return flag !== false;
}
